export const checkContour = (request:any, url:any) => {
  let response:any = ''
  let contour:any = ''

  const contours:any = {
    'demo': {
      props: ['//demo.leadfrog.pro', '//dev.demo.leadfrog.pro']
    }
  }

  const arr:any = {
    pdf: {
      default: 'prod',
      props: {
        short: ['demo']
      }
    },
    tariff: {
      default: 'long',
      props: {
        short: ['demo']
      }
    },
    shardListLength: {
      default: 'auto',
      props: {
        fixed: ['demo']
      }
    },
    getCountour: {
      default: 'prod',
      props: {
        demo: ['demo']
      }
    }
  }

  let newUrl = new URL(url)
  for(let [name, value] of newUrl.searchParams) {
    if(name == 'contour') {
      contour = value
    }
  }

  if(contour.length == 0) {
    for(let key in contours) {
      contours[key]['props'].forEach((prop:any) => {
        if(url.includes(prop)) {
          contour = key
        }
      })
    }
  }

  for(let key in arr[request]['props']) {
    if(arr[request]['props'][key].indexOf(contour) != -1) {
      response = key
    }
    if(response.length == 0) {
      response = arr[request]['default']
    }
  }

  return response
}
